$(document).ready(function(){
  $('.announcement-wrapper').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow:"<img class='a-left control-c prev slick-prev' width='25' height='25' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0671/5015/1740/files/arrow-left-white.svg?v=1754975900'>",
    nextArrow:"<img class='a-right control-c next slick-next' width='25' height='25' alt='next-arrow' src='https://cdn.shopify.com/s/files/1/0671/5015/1740/files/arrow-right-white.svg?v=1754975900'>"
  });
  $('.product-card-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3.3,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow:"<img class='a-left control-c prev slick-prev' width='38px' height='38px' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/outline-left-arrow.svg?v=1755077369'>",
    nextArrow:"<img class='a-right control-c next slick-next' width='38px' height='38px' alt='next-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/outline-right-arrow.svg?v=1755077370'>",
    responsive: [
      { 
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
        }
      },
      { 
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          dots: true,
            }
          }
      ]
  });
  $('.testimonial-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow:"<img class='a-left control-c prev slick-prev' width='38px' height='38px' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/outline-left-arrow.svg?v=1755077369'>",
    nextArrow:"<img class='a-right control-c next slick-next' width='38px' height='38px' alt='next-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/outline-right-arrow.svg?v=1755077370'>"
  });
  $('.review-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow:"<img class='a-left control-c prev slick-prev' width='38px' height='38px' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/outline-left-arrow.svg?v=1755077369'>",
    nextArrow:"<img class='a-right control-c next slick-next' width='38px' height='38px' alt='next-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/outline-right-arrow.svg?v=1755077370'>",
    responsive: [
      { 
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      { 
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
            }
          }
      ]
  });
  $('.buybox-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: false,
    prevArrow:"<img class='a-left control-c prev slick-prev' width='38px' height='38px' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/black-arrow-circle-left.svg?v=1755322429'>",
    nextArrow:"<img class='a-right control-c next slick-next' width='38px' height='38px' alt='next-arrow' src='https://cdn.shopify.com/s/files/1/0762/5775/5381/files/black-arrow-circle-right.svg?v=1755322430'>"
  });
  $('.main-product-media-slider').slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      asNavFor: '.main-product-thumbnail-slider',
      arrows: false,
      });
     $('.main-product-thumbnail-slider').slick({
      slidesToShow: 14,
      slidesToScroll: 1,
      asNavFor: '.main-product-media-slider',
      focusOnSelect: true,
      dots: false,
      infinite: true,
      arrows: false,
      responsive: [
      { 
        breakpoint: 1200,
        settings: {
          slidesToShow: 10,
        }
      },
      { 
        breakpoint: 560,
        settings: {
          slidesToShow: 5,
            }
          }
      ]
      });














  $('.product-image-slider').slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.product-thumbnail-slider',
      arrows: false,
      prevArrow:"<img class='a-left control-c prev slick-prev' width='25' height='25' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0571/2281/6160/files/Screenshot_6_1.png'>",
      nextArrow:"<img class='a-right control-c next slick-next' width='25' height='25' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0571/2281/6160/files/Screenshot_5.png'>",
        responsive: [
          { 
            breakpoint: 560,
            settings: {
              dots: true
            }
          }
      ]
      });
     $('.product-thumbnail-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product-image-slider',
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      dots: false,
      infinite: true,
      arrows: false,
      prevArrow:"<img class='a-left control-c prev slick-prev' width='25' height='25' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0571/2281/6160/files/Screenshot_6_1.png'>",
      nextArrow:"<img class='a-right control-c next slick-next' width='25' height='25' alt='prev-arrow' src='https://cdn.shopify.com/s/files/1/0571/2281/6160/files/Screenshot_5.png'>"
      });
      
});